import bService from './base-api'
import { CONTRACT_MANAGER_URL } from '../configs/service-url'

const list = async (version) => {
  const url = `${CONTRACT_MANAGER_URL.AGENT}?v=${version}`
  const result = await bService.get(url)

  return result
}

const initData = async () => {
  const url = `${CONTRACT_MANAGER_URL.AGENT}/init-data`
  const result = await bService.get(url)

  return result
}

const info = async (agentId) => {
  const url = `${CONTRACT_MANAGER_URL.AGENT}/${agentId}`
  const result = await bService.get(url)

  return result
}

const create = async (data) => {
  const url = CONTRACT_MANAGER_URL.AGENT
  const result = await bService.post(url, data)

  return result
}

const update = async (agentId, data) => {
  const url = `${CONTRACT_MANAGER_URL.AGENT}/${agentId}`
  const result = await bService.put(url, data)

  return result
}

const exportAgent = async () => {
  const url = `${CONTRACT_MANAGER_URL.AGENT}/export/all`
  const result = await bService.getBlob(url)

  return result
}

export default {
  list,
  initData,
  info,
  create,
  update,
  exportAgent
}
